import { Link } from "gatsby";
import React from "react";
import CustomImage from "../utilities/CustomImage";

const ProjectCard = ({ project, grayBg = true }) => {
  const {
    data: { featured_image, region, title, secondary_image },
    url,
  } = project;

  return (
    <Link to={url} className="h-full">
      <div
        className={`group project-card ${
          grayBg ? "bg-gray-900" : ""
        } hover:bg-brand h-full flex flex-col`}
      >
        {featured_image && (
          <div className="project-card__image flex-1 relative overflow-hidden max-sm:aspect-square aspect-[3/2]">
            <CustomImage
              image={featured_image}
              className="h-full max-sm:aspect-square aspect-[3/2] z-[5]"
            />
            {secondary_image && secondary_image?.gatsbyImageData && (
              <CustomImage
                image={secondary_image}
                className="project-card__secondary-image !absolute top-0 left-0 opacity-0 group-hover:opacity-100 transition-all duration-300 w-full h-full z-10"
              />
            )}
          </div>
        )}
        <div className="project-card__description p-x5s flex-initial min-h-[85px]">
          {title && <h3 className="font-bold card-title">{title}</h3>}
          {region && <small>{region}</small>}
        </div>
      </div>
    </Link>
  );
};

export default ProjectCard;
